import { render, staticRenderFns } from "./SuccessShare.vue?vue&type=template&id=ed2c3efc&"
import script from "./SuccessShare.vue?vue&type=script&lang=js&"
export * from "./SuccessShare.vue?vue&type=script&lang=js&"
import style0 from "./SuccessShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports